import { BreakpointObserver } from '@angular/cdk/layout';
import { NgClass, NgIf } from '@angular/common';
import {
  Component,
  ElementRef,
  inject,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { MenuModule } from 'primeng/menu';
import { SkeletonModule } from 'primeng/skeleton';
import { StyleClassModule } from 'primeng/styleclass';
import { ToastModule } from 'primeng/toast';
import { Observable, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { ApprezzoCommonModule } from '../../../apprezzoo-common.module';
import { AuthService } from '../../../services/auth/auth.service';
import { DialogService } from '../../../services/dialog-service.service';
import { PagesService } from '../../../services/pages/pages.service';
import { LoginSignupComponent } from '../../public/login-signup/login-signup.component';

@Component({
  selector: 'app-mobile-nav',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [
    TranslocoDirective,
    DialogModule,
    LoginSignupComponent,
    SkeletonModule,
    MenuModule,
    ToastModule,
    NgIf,
    ApprezzoCommonModule,
    NgClass,
    ButtonModule,
    StyleClassModule,
  ],
  templateUrl: './mobile-nav.component.html',
  styleUrl: './mobile-nav.component.scss',
})
export class MobileNavComponent implements OnInit, OnDestroy {
  @Input() isPrivate: boolean = false;

  private readonly destroy$ = new Subject<void>();

  pagesService = inject(PagesService);
  translocoService = inject(TranslocoService);
  router = inject(Router);
  authService = inject(AuthService);
  dialogService = inject(DialogService);
  breakpointObserver = inject(BreakpointObserver);
  items$: Observable<MenuItem[]> = this.pagesService.getPages();
  isLoggedIn$: Observable<boolean> = this.authService.isLoggedIn$;
  isVisible = false;
  currentLang: string = '';
  currentUrl = '';
  menuVisible = true;
  isMobile = false;
  isAppMobile = false;
  @ViewChild('menuButton', { static: false }) menuButton!: ElementRef;

  constructor() {}

  ngOnInit(): void {
    this.dialogService.hideDialog();
    this.dialogService.dialogVisibility$
      .pipe(takeUntil(this.destroy$))
      .subscribe((visible) => (this.isVisible = visible));
    this.currentLang = this.translocoService.getActiveLang();
    this.currentUrl = this.router.url;

    this.isLoggedIn$.pipe(take(1)).subscribe((ele) => {
      if (ele) {
        this.isAppMobile = true;
      }
    });
    this.breakpointObserver.observe('(max-width: 991px)').subscribe((result) => {
      this.isMobile = result.matches;
    });
  }

  navigateAndClose(url: string): void {
    this.pagesService.toggleMenu();

    setTimeout(() => {
      this.router.navigate([url]);
    }, 100);
  }

  isActive(url: string): boolean {
    const currentSegments = this.router.url.split('/').filter(Boolean);
    const targetSegments = url.split('/').filter(Boolean);

    return currentSegments[0] === targetSegments[0] && currentSegments[1] === targetSegments[1];
  }

  login() {
    this.isVisible = true;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
